module.exports = __webpack_public_path__ + "eac0d68528918b10bfc81b46c1fb5dd6.svg";